import { $qs, $setAttr, $setCss } from 'fxdom/es';
import { MuiF } from '../../../../../Mui/F/Function/module/MuiF.js';
import { OMPCoreUtilF } from '../../../Util/F/Function/module/OMPCoreUtilF.js';
import { OMPCoreChannelTalkMuiF } from '../Mui/module/OMPCoreChannelTalkMuiF.js';
import { productThumbnailMigrationForCustomer } from '../../../../../Maker/F/Migrate/thumbnail.js';

function getChannelLocale(lang) {
  if (lang == 'kr') return 'ko';
  if (lang == 'en') return 'en';
  if (lang == 'jp') return 'ja';
}

const channelTalk_blackList = [
  ['omp', 'product', 'detail'], // 상품 상세에는 채널톡을 그리지 않음.
  ['omp', 'kit'], // 키트 상품 상세에는 채널톡을 그리지 않음.
  ['omp', 'ip-merch'], // IP 소개서 페이지에는 채널톡을 그리지 않음.
  ['omp-custom-store'], // 커스텀 스토어에는 채널톡을 그리지 않음.
  ['only-mp-thumbnail'], // 썸네일 표시 페이지
];

export const loadChannelIO = () => {
  const w = window;
  if (w.ChannelIO) {
    w.console.error('ChannelIO script included twice.');
  }
  const ch = function () {
    ch.c(arguments);
  };
  ch.q = [];
  ch.c = function (args) {
    ch.q.push(args);
  };
  w.ChannelIO = ch;
  function l() {
    if (w.ChannelIOInitialized) {
      return;
    }
    w.ChannelIOInitialized = true;
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js';
    const x = document.getElementsByTagName('script')[0];
    if (x.parentNode) {
      x.parentNode.insertBefore(s, x);
    }
  }
  if (document.readyState === 'complete') {
    l();
  } else {
    w.addEventListener('DOMContentLoaded', l);
    w.addEventListener('load', l);
  }
  w.ChannelIO(
    'boot',
    {
      pluginKey: '76f20dbe-67a5-413b-910e-0146f0acdf13', // fill your plugin key
      language: getChannelLocale(T.lang),
      customLauncherSelector: '.live_chat',
      hideChannelButtonOnBoot: isHiddenChannelTalkButtonPage(),
      ...(box.sel('is_user')
        ? {
            id: box.sel('is_user -> id'),
            userId: box.sel('is_user -> id'),
            profile: {
              // fill user's profile
              name: box.sel('is_user -> name'),
              email: box.sel('is_user -> email'),
            },
          }
        : {}),
    },
    () => {
      const params = new URLSearchParams(window.location.search);
      const user_chat_id = params.get('user_chat_id');
      if (user_chat_id) {
        w.ChannelIO('openChat', user_chat_id);
      }

      const user = box.sel('is_user');

      const webhookToken = process.env.CHANNELTALK_WEBHOOK_TOKEN;
      w.ChannelIO('updateUser', {
        language: getChannelLocale(T.lang), // sync user language
        profile: {
          signin: !!user,
          webhookToken,
        },
      });
    },
  );

  if (OMPCoreUtilF.isMobile()) {
    w.ChannelIO('onShowMessenger', function () {
      $setAttr({ style: 'z-index:10000000 !important; display: block !important;' }, $qs('#ch-plugin'));
      return MuiF.openFrame(OMPCoreChannelTalkMuiF.frame, (f) => {
        f.closing = function (_, pass) {
          pass || w.ChannelIO('hideMessenger');
        };
      });
    });
    w.ChannelIO('onHideMessenger', function () {
      $setCss({ display: '' }, $qs('#ch-plugin'));
      if ($qs('.don_frame.fake-channel-talk-frame')) {
        return MuiF.closeFrame();
      }
    });
  }
  w.ChannelIO('onShowMessenger', function () {
    productThumbnailMigrationForCustomer().then();
  });

  w.ChannelIO('onChatCreated', (chatId) => {
    console.log('Chat created with ID:', chatId);
  });
};

function isHiddenChannelTalkButtonPage() {
  function hasAnyClassSet(element, classSets) {
    return classSets.some((classSet) => classSet.every((className) => element.classList.contains(className)));
  }
  return hasAnyClassSet($qs('html'), channelTalk_blackList);
}
